import ReactDOM from "react-dom";
import Container, { ContainerProps } from "./Container";

const Gallery: React.FC<ContainerProps> = (props) => {
  return ReactDOM.createPortal(<Container {...props} />, document.body);
};

export default Gallery;
